import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import dayjs from 'dayjs'
import { isBlockEnv } from '@/utils/constant'
import { withRouter } from 'react-router-dom';

import _ from 'lodash';
const dataProps = {
  status: 1,
  "prizes": [
    {
      "promotionBagId": "1163745659515514881",
      "promotionBagName": "极速打车10元立减优惠券",

      "coupons": [{
        "title": "极速打车优惠券",
        "expireEndTime": 1569859199000,
        "couponType": 1,
        cashCoupon: {
          couponAmount: 1000
        },
      },
      {
        "title": "极速打车优惠券",
        "expireEndTime": 1569859199000,
        "couponType": 2,
        discountCoupon: {
          discount: 750,
          orderAmount: 100,
          maximumDeduction: 1000
        },
      },
      {
        "title": "极速打车优惠券",
        "expireEndTime": 1569859199000,
        "couponType": 3,
        fullReduceCoupon: {
          reduceAmount: 1000,
          orderAmount: 5000,
          maximumDeduction: 10000
        },
      },
      {
        "title": "极速打车优惠券",
        "expireEndTime": 1569859199000,
        "couponType": 4,
        freeCoupon: {
          freeAmount: 5000
        },
      },
    ]
    }]
}
class Coupon extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    coupon: PropTypes.object,
  }

  couponTypeHTML = (item) => {
    switch (item.couponType) {
      case 4:
        return <div className="coupon-left-middle"><strong>免单</strong></div>
      case 3:
        return (
          <div className="coupon-left-top">
            <em>{item.fullReduceCoupon.reduceAmount / 100}</em><span className="unit">元</span>
            <div className="coupon-left-bottom">
              满{item.fullReduceCoupon.orderAmount / 100}元立减
                  </div>
          </div>
        )
      case 2:
        return (
          <div className="coupon-left-top">
            <em>{(item.discountCoupon.discount / 100).toFixed(1)}</em><span className="unit">折</span>
            <div className="coupon-left-bottom">
              最高立减<p>{item.discountCoupon.maximumDeduction / 100}元</p>
            </div>
          </div>
        )


      default:
        return (
          <div className="coupon-left-top">
            <em>{item.cashCoupon.couponAmount / 100}</em><span className="unit">元</span>
            <div className="coupon-left-bottom">
              无门槛立减
            </div>
          </div>
        )

    }

  }



  render() {
    const { coupon, couponBg, color } = this.props;
    return (
      <>
        <div className="coupon" style={{ color: color, backgroundImage: `url(${couponBg})` }}>
          <div className="coupon-left">
            {this.couponTypeHTML(coupon)}
          </div>
          <div className="coupon-right">
            <div className="coupon-content">
              <div className="coupon-left-top">
                {coupon.title}
              </div>
              <div className="coupon-left-bottom">
                有效期至{dayjs(coupon.expireEndTime).format('YYYY-MM-DD')}
              </div>
            </div>
            <div className="coupon-option">
              {this.props.children}
            </div>
          </div>
          <div className="note">掌铁APP通用</div>
        </div>
      </>
    );
  }
}
@withRouter
class Index extends PureComponent {
  state = {
    data: { prizes: [] }
  }

  async componentDidMount() {

    if (isBlockEnv) {
      const blockProps = _.isEmpty(this.props.prizes) ? dataProps : this.props;
      this.setState({ data: blockProps })
    } else {
      if (!window._ACCESSTOKEN_) {
        this.props.history.replace('/');
      } else {
        this.setState({ data: this.props })
      }
    }
  }

  render() {
    const { data } = this.state;
    const { prizes, status } = data;
    const { couponBg, color, children } = this.props;
    const visibleChildren = _.filter(children, function (item) { return _.has(item, 'props.visibleCondition') });
    const couponChildren = _.filter(children, function (item) { return !_.has(item, 'props.visibleCondition') });
    // const Components = getComponents(visibleChildren, handleChangePage, restProps)

    return (
      <>
        {/* {(_.get(data, `${visibleCondition}`) === true) && <div >{visibleChildren}</div>} */}
        {(Number(status) === 1) && <div >{visibleChildren}</div>}
        {
          !_.isEmpty(prizes) && prizes.map(prize => {
            return prize.coupons.map((item, index) => (
              <Coupon
                key={index}
                couponBg={couponBg}
                color={color}
                coupon={item}
                children={couponChildren}
              />
            ))
          })
        }
      </>
    )
  }
}
export default Index;

